import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { useGetAllInstoreOffers } from 'core/modules/Instore2/hooks/useGetInstoreOffers';
import MeInstoreOffer from 'core/modules/Instore2/components/MePage/MeInstoreOffer/MeInstoreOffer';
import { getParamsFromSearch } from 'core/utils/helpers/getParamsFromSearch';

import MerchantOffer from '../MerchantOffer/MerchantOffer';

import './MerchantOffers.scss';

function MerchantOffers({ offers }) {
  const location = useLocation();
  const { gmid } = getParamsFromSearch(location.search);
  const { offers: instoreOffers } = useGetAllInstoreOffers();

  const instoreOffer = instoreOffers.find(({ carteraMerchantId }) => carteraMerchantId === Number(gmid));

  if (isEmpty(offers) && isEmpty(instoreOffer)) {
    return null;
  }

  return (
    <ul className="mn_merchantExperienceOffers">
      <MeInstoreOffer offer={instoreOffer} />
      {offers.map(offer => (
        <li key={offer.id} className={`${offer.isFeatured ? 'mn_bonusOffer' : ''}`}>
          <MerchantOffer offer={offer} />
        </li>
      ))}
    </ul>
  );
}

MerchantOffers.propTypes = {
  offers: PropTypes.arrayOf(PropTypes.shape({})),
};

MerchantOffers.defaultProps = {
  offers: [],
};

export default (props) => <ComponentErrorBoundary><MerchantOffers {...props} /></ComponentErrorBoundary>;
